import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import bottleImg from 'src/assets/images/jar_img.png'
import { Header } from 'src/components'
import { BottleParticipants, ConfirmationInfo, Icon, Timer } from 'src/components/ui'
import { useGetBottleById } from 'src/hooks/useGetBottleById'
import { formattedText } from 'src/utils/formattedText'

import { calculateCountdown } from '../../utils/calculateCountdown'
import { BOTTLE_CONDITIONS } from './Bottle.consts'
import styles from './Bottle.module.scss'
import { ParticipantsSection } from './components'

const BottlePage = () => {
  const { id } = useParams()
  const { t } = useTranslation()

  // const [isActiveModal, setIsActiveModal] = React.useState<boolean>(false)
  const [isActiveLoading, setIsActiveLoading] = React.useState<boolean>(false)
  const { bottleData } = useGetBottleById(id || '', true, styles, isActiveLoading)

  const { name, type, entry_sum, start_date, available_until, participant_users, total_stars, total_tickets } =
    bottleData ?? {}

  const { time, message } = calculateCountdown(available_until || '00:00:00', start_date || '00:00:00')
  const planned = message === 'Start is expected'

  // const { error, handleClickWritingStars } = useHandleClickWritingStars(
  //   entry_sum,
  //   setIsActiveModal,
  //   setIsActiveLoading,
  //   type,
  // )

  // const handleContributionConfirmation = async () => {
  //   await handleClickWritingStars()
  //   setIsActiveModal(false)
  //   setIsActiveLoading(false)
  // }

  return (
    <>
      <Header
        variant='time'
        time={planned ? t(message) : time}
        action={planned ? 'text' : undefined}
        path='/'
        share={`bottle_${id}`}
      />

      {/* NOT MVP */}
      {/* <ContributionConfirmationModal
        isActiveModal={isActiveModal}
        isActiveLoading={isActiveLoading}
        setIsActiveModal={setIsActiveModal}
        handleClickWritingStars={handleContributionConfirmation}
      /> */}

      <main>
        <div className={styles.bottle}>
          {/* <p className={styles.bottle_name}>{(!planned && name) || t('confirmation_info.bank_name')}</p> */}

          <ul className={styles.conditions}>
            {BOTTLE_CONDITIONS.map((condition) => (
              <li key={condition}>
                <Icon name='raffle_checkmark' />
                <p>{t(condition)}</p>
              </li>
            ))}
          </ul>

          <img src={bottleImg} className={styles.bottle_img} alt='Bottle with money' />

          <p className={styles.bottle_subtitle}>
            {planned ? t('bottle_page.before_the_stars') : t('bottle_page.total_pool')}
          </p>
          <p className={styles.bottle_title}>
            {planned ? (
              <Timer time={time || '00:00:00'} variant='big' className={styles.bottle_timer} />
            ) : (
              `${formattedText(Math.abs(total_stars || 0))} ${t('main_page.stars')}`
            )}
          </p>
        </div>

        {/* <Properties type={type} User={User} target={target} /> */}

        <div className={styles.participants}>
          {planned && (
            <ConfirmationInfo
              bottleName={name || ''}
              bottleAmount={entry_sum || 0}
              bottleDate={{ from: start_date?.split('T')[0] || '', to: available_until?.split('T')[0] || '' }}
              className={styles.info}
            />
          )}

          {!planned && (
            <ParticipantsSection participantsList={participant_users} type={type || ''} amount={entry_sum || 0}>
              <BottleParticipants
                typeOfBottle={type}
                participantsList={participant_users}
                total_stars={total_stars || 0}
                total_tickets={total_tickets || 0}
                variant='bottle'
              />
            </ParticipantsSection>
          )}
        </div>
      </main>
    </>
  )
}

export default BottlePage
